import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { encryptData, ENDPOINTS } from 'controller/constants';
import { jwtDecode } from 'jwt-decode';

export const login = createAsyncThunk('auth/login', async ({ username, password }, { rejectWithValue }) => {
    try {
        const response = await axios.post(ENDPOINTS.LOGIN, {
            email: username,
            password
        }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        const { access_token } = response.data;
        localStorage.setItem('access_token', encryptData(access_token));
        const user = jwtDecode(access_token);
        localStorage.setItem('user', encryptData(user));
        localStorage.setItem('isLoggedin', encryptData('true'));
        return access_token;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message);
    }
});

export const refresh = createAsyncThunk('auth/refresh', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.post(ENDPOINTS.REFRESH_TOKEN, _, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });
        const { access_token } = response.data;
        localStorage.setItem('access_token', encryptData(access_token));
        const user = jwtDecode(access_token);
        localStorage.setItem('user', encryptData(user));
        localStorage.setItem('isLoggedin', encryptData('true'));
        return access_token;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message);
    }
});

export const logout = createAsyncThunk('auth/logout', async () => {
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('isLoggedin');
    return {};
});